<template>
    <div id="appraisals">
        <router-link
        :to="{name: 'new_appraisal', params: {}}"
        class="ui basic positive button"
        >
            <i class="plus icon"></i>
            <!-- 新增考績 -->
            {{ $t('ui.page_titles.new_appraisal') }}
        </router-link>
        <table class="ui celled table">
            <thead>
                <tr>
                    <th>{{ $t('ui.pages.appraisals.point') }}</th>
                    <th>{{ $t('ui.pages.appraisals.reason') }}</th>
                    <th>{{ $t('ui.pages.appraisals.registrant_identity') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <appraisal v-if="is_initialized" v-for="appraisal in appraisals" :key="appraisal.identity" :appraisal="appraisal" />
            </tbody>
        </table>
    </div>
</template>

<script>
import appraisal from "../.components/index/appraisal.vue"
export default {
    data: function () {
        return {
            appraisals: [],
            is_initialized: false,
        }
    },
    computed: {
    },
    created: function() {
        var that = this;
        that.init();
    },
    mounted: function() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "appraisals") {
                this.init();
            }
        },
    },
    methods: {
        init: async function() {
            var that = this;
            await new Promise(resolve => {
                that.is_initialized = false;
                resolve();
            });
            await that.fetch_appraisals();
            await new Promise(resolve => {
                that.is_initialized = true;
                resolve();
            });
        },
        fetch_appraisals: function() {
            var that = this;
            var url = new RestUrl(that.$store.state.provider.routes.api_v1_provider_staff_appraisals).parse(
                {"identity": that.$route.params.staff_identity},
                ""
            );
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    that.appraisals = response.data.appraisals;
                    return response;
                })
                .catch(function (error) {
                    // that.$noty.error('取得appraisals失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.fetch__name', {
                            name: that.$t('models.appraisals'),
                            reason: ': ' + error
                        })
                    );
                    return Promise.reject(error);
                });
        }
    },
    components: {
        appraisal,
    }
}
</script>
